import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BotsService } from '../../api';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'tg-dialog-create-bot',
    templateUrl: './dialog-create-bot.component.html',
    styleUrls: ['./dialog-create-bot.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DialogCreateBotComponent implements OnInit {
  token = new UntypedFormGroup({ token: new UntypedFormControl() });

  constructor(public dialogRef: MatDialogRef<DialogCreateBotComponent>, private botsService: BotsService) {}

  ngOnInit() {}

  saveToken() {
    return () => this.botsService.createBot(this.token.value);
  }

  botCreated(res) {
    this.dialogRef.close({
      msg: $localize`:Create bot dialog|notify @@createBotDialog.createSuccess:Бот успешно подключен`,
      res,
    });
  }
}
